const indexItems = [
  { icon: 'ri-fire-fill', title: '每日黑料合集', desc: '每日精选猛料合集' },
  { icon: 'ri-movie-2-line', title: '娱乐圈深扒', desc: '明星艺人全追踪' },
  { icon: 'ri-global-line', title: '社会观察', desc: '热点事件深度解析' },
  { icon: 'ri-funds-line', title: '财经解密', desc: '商业内幕与投资' },
  { icon: 'ri-cpu-line', title: '科技前沿', desc: '数码新品与趋势' },
  { icon: 'ri-lightbulb-line', title: '生活指南', desc: '实用百科与技巧' },
  { icon: 'ri-earth-line', title: '国际视野', desc: '全球资讯一览' },
  { icon: 'ri-archive-line', title: '历史档案', desc: '经典回顾与复盘' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3 tracking-tight">
          主题索引
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10">
          全站内容分类导航
        </p>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4 max-w-4xl mx-auto">
          {indexItems.map((item) => (
            <a
              key={item.title}
              href="#"
              onClick={(e) => e.preventDefault()}
              className="flex flex-col items-center gap-2 p-4 md:p-5 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200/60 hover:bg-background-50 transition-all duration-200 text-center cursor-pointer group"
            >
              <div className="w-10 h-10 rounded-xl bg-primary-100 flex items-center justify-center group-hover:bg-primary-200 transition-colors duration-200">
                <i className={`${item.icon} text-lg text-primary-600`}></i>
              </div>
              <h3 className="font-medium text-foreground-800 text-sm whitespace-nowrap">
                {item.title}
              </h3>
              <p className="text-foreground-400 text-xs">{item.desc}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}